import React from 'react';

const HomeStats = () => {
    return (
        <div className='bg-[#EAEEFB] py-10 px-4 sm:px-6 md:px-10 lg:px-16 xl:px-24 2xl:px-32'>
            <div className='flex flex-col sm:flex-row justify-center items-center gap-6 flex-wrap'>

                <div className='bg-white w-[200px] sm:w-[160px] md:w-[170px] lg:w-[180px] xl:w-[340px] 2xl:w-[360px] py-4 px-2 flex flex-col items-center gap-1.5 rounded shadow-md'>
                    <p className='text-[28px] sm:text-[30px] md:text-[32px] font-semibold text-[#2F55D4]'>100+</p>
                    <p className='text-[12px] sm:text-[13px] md:text-[14px] font-bold text-center text-[#2F55D4] leading-snug'>PROJECTS DELIVERED</p>
                </div>

                <div className='bg-white w-[200px] sm:w-[160px] md:w-[170px] lg:w-[180px] xl:w-[340px] 2xl:w-[360px] py-4 px-2 flex flex-col items-center gap-1.5 rounded shadow-md'>
                    <p className='text-[28px] sm:text-[30px] md:text-[32px] font-semibold text-[#2F55D4]'>4+</p>
                    <p className='text-[12px] sm:text-[13px] md:text-[14px] font-bold text-center text-[#2F55D4] leading-snug'>YEARS IN OPERATION</p>
                </div>

                <div className='bg-white w-[200px] sm:w-[160px] md:w-[170px] lg:w-[180px] xl:w-[340px] 2xl:w-[360px] py-4 px-2 flex flex-col items-center gap-1.5 rounded shadow-md'>
                    <p className='text-[28px] sm:text-[30px] md:text-[32px] font-semibold text-[#2F55D4]'>1</p>
                    <p className='text-[12px] sm:text-[13px] md:text-[14px] font-bold text-center text-[#2F55D4] leading-snug'>GLOBAL OFFICES</p>
                </div>

            </div>
        </div>
    );
};

export default HomeStats;
